import type { ReactNode } from "react";
import { FormPageAlert } from "./fields";
import { WizardNav } from "./WizardNav";

interface Props {
  title: string;
  children: ReactNode;
  onBack: () => void;
  onContinue: () => void;
  hasErrors?: boolean;
  backLabel?: ReactNode;
  continueLabel?: ReactNode;
  continueDisabled?: boolean;
  showContinue?: boolean;
}

export function WizardPage({
  title,
  children,
  onBack,
  onContinue,
  hasErrors = false,
  backLabel,
  continueLabel,
  continueDisabled,
  showContinue,
}: Props) {
  return (
    <form
      className="card"
      noValidate
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <h2 className="nv-sr-only" data-step-heading tabIndex={-1}>
        {title}
      </h2>

      <div className="nv-card-scroll">
        {children}
        <FormPageAlert show={hasErrors} />
      </div>

      <WizardNav
        onBack={onBack}
        onContinue={onContinue}
        backLabel={backLabel}
        continueLabel={continueLabel}
        continueDisabled={continueDisabled}
        showContinue={showContinue}
      />
    </form>
  );
}
